module.exports = __webpack_public_path__ + "static/media/approval.inactive.635ff4b9.svg";